import React from 'react';
import Icon from './Icon';
import styled from 'styled-components';
import {Wrapper, Text, IconWrapper, Image} from '../styles';
import TrackButton from './TrackButton';
import appConfig from '../../../../app-config';
import moment from 'moment';

const Button = styled.a`
  color: ${props => props.theme.bodyColor};
  font-weight: ${props => (props.secondary ? '400' : '600')};
  cursor: pointer;
  font-size: 15px;
  background: none;
  border: none;
  text-decoration: none;
  font-family: ${props => props.theme.primaryFontFontFamily};
  border-radius: 17.5px;
  padding: 7px 16px;
  color: ${props => props.theme.orderStatusTrackTextColor};
  background: ${props => props.theme.orderStatusTrackBackgroundColor};
`;

const ButtonWrapper = styled.div`
  display: grid;
  grid-gap: 15px;
`;

const SubText = styled.a`
  color: #737a87;
  font-size: 14px;
  margin-left: 1px;
`;

const OrderOnDelivery = ({orderStatus}) => {
  return (
    <Wrapper>
      <IconWrapper>
        {appConfig.orderStatusImages &&
        appConfig.orderStatusImages.order_on_delivery ? (
          <Image src={appConfig.orderStatusImages.order_on_delivery} />
        ) : (
          <Icon
            className={
              (appConfig.orderStatusIcons &&
                appConfig.orderStatusIcons.order_on_delivery) ||
              'fas fa-car-side'
            }
          />
        )}
      </IconWrapper>
      <ButtonWrapper>
        {orderStatus.delivery_tracking_url ? (
          <TrackButton
            id="OrderDelivery-TrackButton"
            orderStatus={orderStatus}
          />
        ) : appConfig.appSource === 'janus' ? null : (
          <div>
            <Text id="OrderDelivery-OutForDelivery">
              Your order is out for delivery
            </Text>
            <SubText>{`Your order will be delivered by ${moment(
              orderStatus.estimatedTime
            ).format('hh:mm')}`}</SubText>
          </div>
        )}
      </ButtonWrapper>
    </Wrapper>
  );
};

export default OrderOnDelivery;
